import { initializeTable } from '../tables';
import RowContextMenuButtonColumn from '../formatters/RowContextMenuButtonColumn';
import { getCookie } from '../../utils';
import { addAlert } from '../../alerts';

export default function initializeComponentListTable({ ...options }) {
    const rootElement = document.querySelector('#componentListTable');

    const forcedFilter = [];
    const pillsContainerSelector = '.active-filters-container';
    const canViewCatalog = rootElement.dataset.userCanViewCatalog === 'true';

    initializeTable({
        tableElement: rootElement,
        filtersElement: document.querySelector(
            '#componentListFilters .form-fields',
        ),
        tabsElement: document.querySelector('.table-tabs'),
        ajaxURL: rootElement.dataset.ajaxUrl,
        forcedFilter: forcedFilter,
        pillsConfig: {
            containerSelector: pillsContainerSelector,
            ignoreFields: [],
        },
        rowContextMenu: function (e, row) {
            const rowData = row.getData();
            let menu = [
                {
                    label: gettext('Szczegóły'),
                    action: function (e, row) {
                        window.location.href = rowData.detail_url;
                    },
                },
                {
                    label: gettext('Katalogowanie podzespołów'),
                    action: function (e, row) {
                        window.location.href = rowData.catalog_url;
                    },
                    disabled: !canViewCatalog,
                },
            ];
            menu = menu.filter((item) => item);
            return menu;
        },
        columns: [
            { title: '#', formatter: 'rownum', width: 60, headerSort: false },
            {
                title: gettext('Kod'),
                field: 'enova_id',
                headerSortFieldName: 'enova_id',
                resizable: false,
            },
            {
                title: gettext('Grupa'),
                field: 'enova_data.group',
                headerSortFieldName: 'enova_data__group',
                resizable: false,
            },
            {
                title: gettext('Typ'),
                field: 'enova_data.type',
                headerSortFieldName: 'enova_data__type',
                resizable: false,
            },
            {
                title: gettext('Producent'),
                field: 'enova_data.manufacturer',
                headerSortFieldName: 'enova_data__manufacturer',
                resizable: false,
            },
            {
                title: gettext('Model'),
                field: 'enova_data.model',
                headerSortFieldName: 'enova_data__model',
                resizable: false,
            },
            {
                title: gettext('Akcja'),
                resizable: false,
                headerSort: false,
                width: 100,
                formatter: RowContextMenuButtonColumn,
            },
        ],
        ...options,
    });
}
